function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2cb123de\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../../node_modules/iview-loader/index.js??ref--1-1!./CaseTable.vue")
  require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2cb123de\",\"scoped\":false,\"hasInlineConfig\":false}!stylus-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!../../../../node_modules/iview-loader/index.js??ref--1-1!./CaseTable.vue")
}
var normalizeComponent = require("!../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../../node_modules/iview-loader/index.js??ref--1-1!./CaseTable.vue"
import __vue_script__ from "!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../../node_modules/iview-loader/index.js??ref--1-1!./CaseTable.vue"
/* template */
import __vue_template__ from "!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2cb123de\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../../node_modules/iview-loader/index.js??ref--1-1!./CaseTable.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cb123de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/base/table/CaseTable.vue
// module id = null
// module chunks = 